import { NgModule } from '@angular/core';
import { DeliveryCmsComponents } from '@core/const';
import {
  DELIVERY_FEATURE_LAZY,
  DELIVERY_UI_DELIVERY_CALCULATOR_FORM_LAZY,
  DELIVERY_UI_DELIVERY_MAP_LAZY,
} from '@delivery/const';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        [DELIVERY_FEATURE_LAZY]: {
          module: () => import('./lazy/delivery-feature-lazy.module').then((m) => m.DeliveryFeatureLazyModule),
        },
        [DELIVERY_UI_DELIVERY_CALCULATOR_FORM_LAZY]: {
          module: () =>
            import('./lazy/delivery-calculator-form-lazy.module').then((m) => m.DeliveryCalculatorFormLazyModule),
          cmsComponents: [DeliveryCmsComponents.SdCMSDeliveryCalculatorFormComponent],
        },
        [DELIVERY_UI_DELIVERY_MAP_LAZY]: {
          module: () => import('./lazy/delivery-map-lazy.module').then((m) => m.DeliveryMapLazyModule),
          cmsComponents: [DeliveryCmsComponents.SdCMSDeliveryMapComponent],
        },
      },
    }),
  ],
})
export class SdvorDeliveryShellModule {}
